// cn, told the type scale of application.css (text-note, text-body,
// text-title, text-figure): without it they read as colours, and a
// component's own text colour is merged away under them
// (cn's "Custom themes": https://github.com/shadcn-ui/cn#custom-themes)
import type { CnFunction } from "cn"
import { createCn } from "cn/config"

export const cn: CnFunction = createCn({
  extend: { classGroups: { "font-size": [{ text: ["note", "body", "title", "figure"] }] } },
})
